export default __webpack_public_path__ + "images/PK.f40ab79.png";